import { Link } from "react-router-dom";

const css = `
  .legal-page { min-height:100vh; background:var(--bg); padding:48px 24px 80px; }
  .legal-wrap { max-width:720px; margin:0 auto; }
  .legal-logo { font-family:var(--head); font-size:22px; font-weight:800; letter-spacing:2px; margin-bottom:48px; display:inline-block; }
  .legal-logo span { color:var(--blue); }
  .legal-page h1 { font-family:var(--head); font-size:32px; font-weight:800; letter-spacing:2px; margin-bottom:8px; }
  .legal-page .updated { color:var(--muted); font-size:13px; margin-bottom:40px; }
  .legal-page h2 { font-family:var(--head); font-size:16px; font-weight:700; letter-spacing:1px; margin:32px 0 10px; color:var(--blue); text-transform:uppercase; }
  .legal-page p, .legal-page li { font-size:15px; line-height:1.7; color:var(--muted); margin-bottom:12px; }
  .legal-page li { margin-left:20px; list-style:disc; }
  .legal-page a { color:var(--blue); text-decoration:none; }
  .legal-back { display:inline-flex; align-items:center; gap:6px; color:var(--muted); font-size:13px; text-decoration:none; margin-top:40px; }
  .legal-back:hover { color:var(--text); }
`;

export default function Terms() {
  return (
    <>
      <style>{css}</style>
      <div className="legal-page">
        <div className="legal-wrap">
          <Link to="/" className="legal-logo">NEO<span> DETAIL</span></Link>
          <h1>TERMS OF SERVICE</h1>
          <div className="updated">Last updated: May 3, 2026</div>

          <p>These Terms of Service ("Terms") govern your use of the NEO Detail platform ("Service") operated by NEO Detail LLC ("we," "us," or "our"). By creating an account or using the Service, you agree to these Terms.</p>

          <h2>1. The Service</h2>
          <p>NEO Detail provides a software platform for independent mobile detailers to manage bookings, accept payments, and operate their businesses online. We are not a detailing service provider — we are a software company.</p>

          <h2>2. Accounts</h2>
          <p>You must provide accurate information when creating an account. You are responsible for maintaining the security of your account credentials and for all activity that occurs under your account.</p>

          <h2>3. Subscriptions & Billing</h2>
          <ul>
            <li>The Free plan is available at no cost with limited features.</li>
            <li>The Pro plan is billed at $29.00/month or $290.00/year, charged in advance.</li>
            <li>Subscriptions automatically renew at the end of each billing period unless cancelled.</li>
            <li>All prices are in USD. Applicable taxes may be added based on your location.</li>
            <li>We reserve the right to change pricing with 30 days advance notice.</li>
          </ul>

          <h2>4. Cancellation & Refunds</h2>
          <ul>
            <li>You may cancel your Pro subscription at any time through your billing portal.</li>
            <li>Cancellations take effect at the end of the current billing period — you retain Pro access until then.</li>
            <li>We do not offer refunds for partial billing periods.</li>
            <li>Upon cancellation, your account reverts to the Free plan. Your data is retained.</li>
          </ul>

          <h2>5. Payments via Stripe Connect</h2>
          <p>If you use Stripe Connect to accept deposits from customers, you are subject to <a href="https://stripe.com/legal/connect-account" target="_blank" rel="noreferrer">Stripe's Connected Account Agreement</a>. NEO Detail is not responsible for disputes between you and your customers, payment failures, or Stripe account suspensions.</p>

          <h2>6. Acceptable Use</h2>
          <p>You agree not to use the Service for any unlawful purpose, to impersonate others, to transmit spam, or to interfere with the platform's operation. We reserve the right to suspend accounts that violate these Terms.</p>

          <h2>7. Intellectual Property</h2>
          <p>The NEO Detail platform, branding, and code are owned by NEO Detail LLC. Your business data (bookings, services, customer info) remains yours. We do not claim ownership of your content.</p>

          <h2>8. Limitation of Liability</h2>
          <p>To the maximum extent permitted by law, NEO Detail LLC shall not be liable for any indirect, incidental, or consequential damages arising from your use of the Service, including lost revenue, lost customers, or data loss. Our total liability is limited to the amount you paid us in the 3 months preceding the claim.</p>

          <h2>9. Disclaimer of Warranties</h2>
          <p>The Service is provided "as is" without warranties of any kind. We do not guarantee uninterrupted, error-free operation.</p>

          <h2>10. Governing Law</h2>
          <p>These Terms are governed by the laws of the State of Ohio, United States, without regard to conflict of law provisions.</p>

          <h2>11. Changes to Terms</h2>
          <p>We may update these Terms from time to time. We will notify you of material changes by email or through the platform. Continued use of the Service after changes constitutes acceptance.</p>

          <h2>12. Contact</h2>
          <p>Questions about these Terms? Email us at <a href="mailto:support@neodetail.app">support@neodetail.app</a>.</p>

          <Link to="/" className="legal-back">← Back to NEO Detail</Link>
        </div>
      </div>
    </>
  );
}
